$(function() {
    $('.bundle_header').on('click', function(e){
      e.preventDefault();
      if ($(this).hasClass('active')) {
        $('.bundle_header').removeClass('active');
        $('.bundle_collection_main').removeClass('active');
        $('.bundle_collection_main').slideUp();
      } else {
        $('.bundle_header').removeClass('active');
        $('.bundle_collection_main').removeClass('active');
        $('.bundle_collection_main').slideUp();
        $(this).addClass('active');
        $(this).siblings('.bundle_collection_main').addClass('active');
        $(this).siblings('.bundle_collection_main').slideDown();
      }
    })
  
  $('.bundle_collection input').on('click', function(){
    let parentEle = $(this).closest('.bundle_picker_inner');
    if( $(this).is(':checked') ){
      parentEle.removeClass('notSelected');
      parentEle.addClass('selected');
      parentEle.find('.bundle_header').find('.extend_title').html(`<h4>${$(this).attr('data-title')}</h4>`);
    } else {
      parentEle.removeClass('selected');
      parentEle.addClass('notSelected');
      let dataText = parentEle.find('.bundle_header').find('.extend_title').attr('data-text');
      parentEle.find('.bundle_header').find('.extend_title').html(`<h4>${dataText}</h4>`);
    }

    let imgSrc = $(this).attr('data-src');
    if (imgSrc) {
      $('.main_product_media img').removeAttr('srcset')
      $('.main_product_media img').attr('src', imgSrc)
      $('.main_product_media_zoom_icon').hide();
      $('.main_product_media_zoom').hide();
    }    

    
    $this = $('.product-form__submit_bundle');
    let lengthSelected = $('.bundle_picker_inner').length;
    $('.bundle_picker_inner').each(function(){
      if( $(this).hasClass('selected') ){
        lengthSelected = lengthSelected - 1;
      }
    })
    if (lengthSelected == 0) {
      $this.find('span').html('Add To Cart');
      $this.removeClass('disabled');
    }
    
  })

// bundle atc  start
$('.product-form__submit_bundle').on('click', function(e){
    e.preventDefault();
    const $this = $(this);

    // Validate bundle selections
    let notSelected = false;
    $('.bundle_picker_inner').each(function(){
        if(!$(this).hasClass('selected')){
            $(this).addClass('notSelected');
            notSelected = true;
        }
    });
    if(notSelected){
        $this.find('span').html('Please Select All Options').addClass('disabled');
        return;
    }

    $this.find('span').html('Add To Cart').removeClass('disabled');
    $this.find('span').addClass('hidden');
    $this.find('.loading__spinner').removeClass('hidden');

    const variantIds = [];
    $('.bundle_collection input:checked').each(function(){
        variantIds.push($(this).val());
    });

    const discountCode = $this.attr('data-discount'); // discount code

    // Step 1: Add bundle items recursively
    function addVariant(index){
        if(index >= variantIds.length){
            // Step 2: Apply discount via /discount/<CODE> (background fetch)
            if(discountCode){
                fetch(`/discount/${discountCode}`, { method: 'GET', credentials: 'same-origin' })
                    .then(() => {
                        // Step 3: Open cart drawer
                        document.querySelector('#cart-icon-bubble').click();
                        $this.find('span').removeClass('hidden');
                        $this.find('.loading__spinner').addClass('hidden');
                    })
                    .catch(err => {
                        console.error('Error applying discount:', err);
                        document.querySelector('#cart-icon-bubble').click();
                        $this.find('span').removeClass('hidden');
                        $this.find('.loading__spinner').addClass('hidden');
                    });
            } else {
                document.querySelector('#cart-icon-bubble').click();
                $this.find('span').removeClass('hidden');
                $this.find('.loading__spinner').addClass('hidden');
            }
            return;
        }

        const variantId = variantIds[index];
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: { id: variantId, quantity: 1 },
            success: function(){
                addVariant(index + 1);
            },
            error: function(err){
                console.error('Error adding variant:', err);
                addVariant(index + 1);
            }
        });
    }

    addVariant(0); // Start adding
});

//bundle atc end 

  $('.bundle_header .zoom_icon').on('click', function(ev){
    ev.preventDefault();
    ev.stopImmediatePropagation();
    let parentEle = $(this).closest('.bundle_picker_inner');
    if ($(this).hasClass('zoomed')) {
      $(this).removeClass('zoomed')
      parentEle.find('.bundle_collection_main_inner').removeClass('zoomed_in');
    } else {
     $(this).addClass('zoomed')
      parentEle.find('.bundle_collection_main_inner').addClass('zoomed_in');
    }
     
  })
});